import type { SubmissionType } from '@jfh/intake-shared';
import { applicationStatus, applicationType, problemPill } from './wording.js';

type PillSource = Parameters<typeof applicationStatus>[0];

/** The one status pill an application shows (F10: who it's waiting for, or what happened). */
export function ApplicationPill({ sub }: { sub: PillSource }) {
  const s = applicationStatus(sub);
  return (
    <span className={`badge ${s.tone}`}>
      <span className="dot" />
      {s.label}
    </span>
  );
}

/** At most one problem pill ("Not in iQ", "Teams card didn't post"). */
export function ProblemPill({ sub, title }: { sub: Parameters<typeof problemPill>[0]; title?: string }) {
  const text = problemPill(sub);
  if (!text) return null;
  return (
    <span
      title={title}
      style={{
        fontSize: 10.5,
        fontWeight: 700,
        padding: '1px 7px',
        borderRadius: 99,
        background: 'var(--st-declined-soft, #fde8e8)',
        color: 'var(--st-declined)',
      }}
    >
      {text}
    </span>
  );
}

export function TypeBadge({ type }: { type: SubmissionType }) {
  return <span className="badge neutral">{applicationType(type)}</span>;
}

/** Short, mono submission id label, e.g. SUB-1a2b3c4d. */
export function shortId(id: string): string {
  return `SUB-${id.slice(0, 8)}`;
}
